"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrphanNode = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const OrphanNode = ({ size = 16 }) => (react_1.default.createElement(Base_1.Base, { size: size },
    react_1.default.createElement("path", { fill: "#E6E6E6", d: "M3.98,6.99v2.02H3V7.33V6.99H3.98" }),
    react_1.default.createElement("path", { fill: "#92C03E", d: "M9.01,6.99H16V0L9.01,0V6.99z M13,0.98V3h2.02v0.98H13v2.02h-0.98V3.98H9.99V3h2.02V0.98H13z" }),
    react_1.default.createElement("path", { fill: "#8EE43F", d: "M8.65,11.11" }),
    react_1.default.createElement("path", { fill: "#E6E5E5", d: "M6.99,6.99H0L0,0l6.99,0V6.99" }),
    react_1.default.createElement("path", { fill: "#FF626D", d: "M0,16h6.99V9.01H0L0,16z M5.89,13h-4.9v-0.98h4.9 M6.01,12.02V13" })));
exports.OrphanNode = OrphanNode;
//# sourceMappingURL=OrphanNode.js.map